import Swiper, { Autoplay, Pagination } from 'swiper';

export default class Slider {
  /**
   * 店通スライダー
   */
  initTentsuSlider() {
    const swiper = new Swiper('.js-tentsu-slider', {
      modules: [Autoplay, Pagination],
      loop: true,
      slidesPerView: 'auto',
      speed: 500,
      centeredSlides: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.c-tentsu__slider-pagination',
        clickable: true
      },
    });
  }
}
